<template>
  <div class="share-me-wrapper">
    <div class="my-vipkid">
      <img class="back" src="./assets/images/back.png">
      <div class="my-content">
        <img class="me" src="./assets/images/me.png" width="144">
        <div class="title">
          My VIPKID
        </div>
        <div class="info">
          <div class="item" :key="item.name" v-for="item in list">
            <img :src="item.icon" class="icon">
            <div class="text">
              <p>{{ item.number }}</p>
              <p>{{ item.name }}</p>
            </div>
          </div>
          <!-- <div class="item">
            <img src="./assets/images/student.png" class="icon">
            <div class="text">
              <p>1111</p>
              <p>2222</p>
            </div>
          </div>
          <div class="item">
            <img src="./assets/images/class.png" class="icon">
            <div class="text">
              <p>1111</p>
              <p>2222</p>
            </div>
          </div>
          <div class="item">
            <img src="./assets/images/time.png" class="icon">
            <div class="text">
              <p>1111</p>
              <p>2222</p>
            </div>
          </div> -->
        </div>
      </div>
      <img src="./assets/images/oval.png" class="shadow">
    </div>
    <teacher-badge></teacher-badge>
    <badger-sign-up></badger-sign-up>
  </div>
</template>
<script>
import api from '@badger/axios';
import TeacherBadge from '@badger/badge';
import { BadgerSignUp } from '@badger/signup';

export default {
  components: {
    BadgerSignUp,
    TeacherBadge,
  },
  data() {
    return {
      list: {}
    };
  },
  computed: {
    secTeacherId() {
      return this.$route.query.teacherId;
    },
  },
  mounted() {
    this.loadMe();
  },
  methods: {
    loadMe() {
      api.get('/rest/tmobile/api/teacher/mobile/insights/list', {
        teacherId: this.secTeacherId
      }).then((list) => {
        this.list = list;
      });
    }
  }

};
</script>
<style lang="less">
.share-me-wrapper {
  .badger-signup-wrapper {
    width: 100%;
  }
}
</style>

<style lang="less" scoped>
.share-me-wrapper {
  max-width: 750px;
  margin: 0 auto;
  position: relative;
}
.shadow {
  margin: 0 auto;
  width: 347px;
  display: block;
  position: relative;
  margin-top: -20px;
  @media screen and (max-width: 350px) {
    margin-bottom: 20px;
  }
}
.my-vipkid {
  min-height: 521px;
  background: #F85715;
  position: relative;
  overflow: hidden;
}
img.me {
  margin-top: 24px;
}
.title {
  background: url(./assets/images/title.png);
  background-size: 245px 51px;
  width: 245px;
  height: 51px;
  position: relative;
  z-index: 3;
  line-height: 45px;
  font-size: 20px;
  color: #AE5705;
  margin: 0 auto;
  margin-bottom: -20px;
}
.my-content {
  width: 320px;
  position: relative;
  z-index: 2;
  text-align: center;
  margin: 0 auto;
  .info {
    background: #F9993E;
    width: 320px;
    padding: 36px 16px 16px;
    border-radius: 8px;

    .item {
      background: #fff;
      overflow: hidden;
      padding: 10px 24px;
    }
    .icon {
      margin-right: 51px;
      float: left;
      width: 74px;
      height: 52px;
    }
    .text {
      float: left;
      text-align: left;
      p:first-child {
        font-size: 24px;
        color: #060607;
        line-height: 28px;
      }
      p:last-child {
        margin-top: 4px;
        color: #5E6670;
        font-size: 14px;
        line-height: 17px;
        max-width: 115px;
        white-space: nowrap;
      }
    }
    .item:not(:first-child) {
      margin-top: 8px;
    }
  }
}
img.back {
  width: 100%;
  position: absolute;
}

</style>
